<template>
  <div class="index-container">
    <div class="nav">
      <ul>
        <li>
          <router-link to="/discovery">
            <span class="iconfont icon-find-music"></span>
            发现音乐
          </router-link>
        </li>
        <li>
          <router-link to="/playlists">
            <span class="iconfont icon-music-list"></span>
            推荐歌单
          </router-link>
        </li>
        <li>
          <router-link to="/songs">
            <span class="iconfont icon-music"></span>
            最新音乐
          </router-link>
        </li>
        <li>
          <router-link to="/mvs">
            <span class="iconfont icon-mv"></span>
            最新MV
          </router-link>
        </li>
      </ul>
    </div>
    <div class="main">
      <router-view></router-view>
    </div>
    <div class="player">
      <audio :src='musicUrl' controls autoplay></audio>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data() {
    return {
      musicUrl: "http://m801.music.126.net/20240303235007/9c9c52dd46ebc30a45734c94492924d3/jdymusic/obj/wo3DlMOGwrbDjj7DisKw/7154685078/5d4c/eecb/5140/946f07e217e003a5cb3500452dc6d853.mp3"
    };
  },
  methods: {
    changeMusicUrl(url) {
      this.musicUrl = url
    }
  },
};
</script>

<style>

</style>
